import { render, staticRenderFns } from "./BuildingsTableMobile.vue?vue&type=template&id=1931420a&scoped=true&lang=pug"
import script from "./BuildingsTableMobile.vue?vue&type=script&lang=js"
export * from "./BuildingsTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1931420a",
  null
  
)

export default component.exports